/** Stable public landing page, including when the application cannot start. */
export const DESKTOP_DOWNLOAD_URL = "https://compadre.comprehensive.io/download";
